// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Terms & Conditions`
};

const de_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Teilnahmebedingungen`
};

const es_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Términos y Condiciones`
};

const fr_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Conditions Générales`
};

const fi_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Käyttöehdot`
};

const hi_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `नियम एवं शर्तें`
};

const ja_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `利用規約`
};

const nl_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Algemene voorwaarden`
};

const pt_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Termos e Condições`
};

const ro_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Termeni și Condiții`
};

const th_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `ข้อกำหนดและเงื่อนไข`
};

const ur_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `شرائط و ضوابط`
};

const zh_hant1_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `條款與條件`
};

const da_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Vilkår og betingelser`
};

const it_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Termini e Condizioni`
};

const vn_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Điều Khoản & Điều Kiện`
};

const ko_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `이용약관`
};

const tr_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Şartlar ve Koşullar`
};

const lv_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Noteikumi un nosacījumi`
};

const ar_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `الشروط والأحكام`
};

const bs_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Uslovi i odredbe`
};

const sl_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Pogoji uporabe`
};

const id_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Syarat & Ketentuan`
};

const sv_widget_terms_and_conditions = /** @type {(inputs: {}) => string} */ () => {
	return `Villkor & Bestämmelser`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_terms_and_conditions = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_terms_and_conditions(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_terms_and_conditions", locale)
	if (locale === "en") return en_widget_terms_and_conditions(inputs)
	if (locale === "de") return de_widget_terms_and_conditions(inputs)
	if (locale === "es") return es_widget_terms_and_conditions(inputs)
	if (locale === "fr") return fr_widget_terms_and_conditions(inputs)
	if (locale === "fi") return fi_widget_terms_and_conditions(inputs)
	if (locale === "hi") return hi_widget_terms_and_conditions(inputs)
	if (locale === "ja") return ja_widget_terms_and_conditions(inputs)
	if (locale === "nl") return nl_widget_terms_and_conditions(inputs)
	if (locale === "pt") return pt_widget_terms_and_conditions(inputs)
	if (locale === "ro") return ro_widget_terms_and_conditions(inputs)
	if (locale === "th") return th_widget_terms_and_conditions(inputs)
	if (locale === "ur") return ur_widget_terms_and_conditions(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_terms_and_conditions(inputs)
	if (locale === "da") return da_widget_terms_and_conditions(inputs)
	if (locale === "it") return it_widget_terms_and_conditions(inputs)
	if (locale === "vn") return vn_widget_terms_and_conditions(inputs)
	if (locale === "ko") return ko_widget_terms_and_conditions(inputs)
	if (locale === "tr") return tr_widget_terms_and_conditions(inputs)
	if (locale === "lv") return lv_widget_terms_and_conditions(inputs)
	if (locale === "ar") return ar_widget_terms_and_conditions(inputs)
	if (locale === "bs") return bs_widget_terms_and_conditions(inputs)
	if (locale === "sl") return sl_widget_terms_and_conditions(inputs)
	if (locale === "id") return id_widget_terms_and_conditions(inputs)
	if (locale === "sv") return sv_widget_terms_and_conditions(inputs)
	return "widget_terms_and_conditions"
};